import { Controller } from "@hotwired/stimulus"

// Shows the Menge field only while the chosen expense category has a Mengeneinheit and
// labels it with that unit. The unit sits on the category <option>
// (EmployeeExpensesHelper#expense_category_options); a saved expense keeps its own unit
// (saved*Value) while it stays in its category, like ExpenseQuantity#effective_quantity_unit.
// Switching to another unit clears the value — the server drops it as well — and the
// current unit is published as data-quantity-unit for expense_receipt_extraction_controller.
export default class extends Controller {
  static targets = ["input", "unit"]
  static values = { savedCategoryId: String, savedUnit: String, savedSymbol: String }

  connect() {
    this.categorySelect = this.element
      .closest("form")
      ?.querySelector('select[name$="[expense_category_id]"]')
    this.sync = this.sync.bind(this)
    this.categorySelect?.addEventListener("change", this.sync)
    this.render(this.currentUnit())
  }

  disconnect() {
    this.categorySelect?.removeEventListener("change", this.sync)
  }

  sync() {
    const unit = this.currentUnit()
    if (unit.code !== this.element.dataset.quantityUnit && this.hasInputTarget) {
      this.inputTarget.value = ""
    }
    this.render(unit)
  }

  currentUnit() {
    const option = this.categorySelect?.selectedOptions[0]
    if (this.savedUnitValue !== "" && option?.value === this.savedCategoryIdValue) {
      return { code: this.savedUnitValue, symbol: this.savedSymbolValue }
    }
    return {
      code: option?.dataset.quantityUnit || "",
      symbol: option?.dataset.quantityUnitSymbol || "",
    }
  }

  render({ code, symbol }) {
    this.element.dataset.quantityUnit = code
    this.element.classList.toggle("hidden", code === "")
    if (this.hasUnitTarget) this.unitTarget.textContent = symbol
  }
}
